export default "__VITE_ASSET__CsmakU1O__"